import { WifiOff } from 'lucide-react';
import { useOnline } from '../lib/useOnline';

/**
 * «Sin conexión» across the top of every page while the device is offline; gone when it is back.
 * Pages keep what they had already loaded, which is what the banner says. Without it, a phone
 * that lost signal showed each page's own «no hemos podido cargar…» or an empty list, which read
 * as the data or the app being broken.
 *
 * Two placements, one visible at a time: inside the sticky web header (so it stays in view as the
 * page scrolls), and on its own for the native app, which hides the web header (index.css).
 * The live region is always in the DOM, so the change is announced when it happens.
 */
export default function OfflineBanner({ placement = 'header' }) {
  const online = useOnline();
  return (
    <div role="status" aria-live="polite" className={placement === 'app' ? 'offline-banner-app' : undefined}>
      {!online && (
        <div className="bg-slate-800 text-white" data-testid={`offline-banner${placement === 'app' ? '-app' : ''}`}>
          <p className="max-w-screen-xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2 text-xs font-bold text-center">
            <WifiOff size={14} aria-hidden="true" className="shrink-0" />
            Sin conexión. Mostrando lo último que se cargó.
          </p>
        </div>
      )}
    </div>
  );
}
